import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PROGRESS_LANES } from "../../common/constants";
import { deriveOrderProgress, getItemProgress, getProgressLane } from "../../common/util";
import ProgressRing from "./ProgressRing";

// Read-only summary; progress is updated on each item.
export default function OrderProgress(props) {
  const { order, size } = props;

  const [open, setOpen] = useState(false);

  const items = order.items || [];
  const itemLanes = items.map((item) => getProgressLane(getItemProgress(order, item)));
  const doneCount = itemLanes.filter((o) => o === "completed").length;
  const { pct, lane } = deriveOrderProgress(order);

  const renderLaneIcon = (key) => (
    <Tooltip title={PROGRESS_LANES[key].label}>
      <span role="img" aria-label={PROGRESS_LANES[key].label}>
        {PROGRESS_LANES[key].emoji}
      </span>
    </Tooltip>
  );

  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      <ProgressRing pct={pct} size={size} onClick={() => setOpen(true)} />
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true} maxWidth="xs">
        <DialogTitle>
          Order Progress
          {items.length > 0 && (
            <Typography
              variant="body2"
              color="textSecondary"
              component="span"
              sx={{ display: "block" }}
            >
              {`${doneCount}/${items.length} items completed`}
            </Typography>
          )}
        </DialogTitle>
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {items.length > 0
            ? items.map((item, idx) => (
                <Box
                  key={idx}
                  my={1.5}
                  sx={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}
                >
                  {renderLaneIcon(itemLanes[idx])}
                  <Typography variant="body1" noWrap>
                    {`${item.quantity || 1}x ${item.title || item.type}`}
                  </Typography>
                </Box>
              ))
            : `${PROGRESS_LANES[lane].emoji} ${PROGRESS_LANES[lane].label}`}
        </DialogContent>
      </Dialog>
    </span>
  );
}
